import { Slide } from '@features/powerpoint';
import { BuildReportOptions } from './build-presentation';
import {
  visibleSlide,
  meetYourTeamSlide,
  agendaSlide,
  navigatingComplexitySlide,
  incrementalityMattersSlide,
  coverSlide,
  titleSlide,
  recommendationsSlide,
} from '@features/executive-report/slides';
import { campaignOverviewSlide } from '../slides/campaign-overview/campaign-overview';
import { discoverWhatsNextSlide } from '@features/executive-report/slides/discover-whats-next';
import { campaignOverviewSlide2 } from '../slides/campaign-overview-2/campaign-overview-2';
import { salesDimensionsSlides } from '../slides/sales-dimensions/sales-dimensions';
import { headerTabs } from '../slides/header-tabs';

export type BuildReportOptionsV1 = Extract<
  BuildReportOptions,
  { designVersion: 'v1' }
>;

export const buildSlidesV1 = (options: BuildReportOptionsV1): Slide[] => {
  return [
    ...visibleSlide({
      slide: titleSlide(
        options.campaign,
        options.brandLogo,
        options.customFields.campaignName
      ),
      visible: options.customFields.includedSlides.intro.title,
    }),
    ...visibleSlide({
      slide: meetYourTeamSlide({
        teamMembers: options.customFields.teamMembers,
      }),
      visible: options.customFields.includedSlides.intro.meetYourTeam,
    }),
    ...visibleSlide({
      slide: agendaSlide([
        { title: 'The Who', text: ' – Audience' },
        { title: 'The What', text: ' – Creative' },
        { title: 'The Where', text: ' – Channels' },
        { title: 'The How', text: ' – Retailers where purchase happened' },
      ]),
      visible: options.customFields.includedSlides.intro.agenda,
    }),
    ...visibleSlide({
      slide: navigatingComplexitySlide(),
      visible: options.customFields.includedSlides.intro.navigatingComplexity,
    }),
    ...visibleSlide({
      slide: incrementalityMattersSlide({
        liftText: 'lift in item level sales',
      }),
      visible: options.customFields.includedSlides.intro.incrementalityMatters,
    }),
    ...visibleSlide({
      slide: coverSlide({ titleText: 'Sales Attribution' }),
      visible: options.customFields.includedSlides.sales.cover,
    }),
    ...visibleSlide({
      slide: campaignOverviewSlide({
        campaign: {
          ...options.campaign,
          adSpend: options.campaign.adSpend,
        },
        report: options.report,
        brandLogoWithMetadata: options.brandLogo,
        dimensionCounts: [
          options.subdimensionCounts.aud ?? 0,
          options.subdimensionCounts.creative ?? 0,
          options.subdimensionCounts.channel ?? 0,
          options.retailerCount,
        ],
      }),
      visible: options.customFields.includedSlides.sales.campaignOverview,
    }),
    ...visibleSlide({
      slide: campaignOverviewSlide2({
        report: options.report,
        brandLogoWithMetadata: options.brandLogo,
        objectives: options.customFields.salesObjectives.map(
          objective => objective.value
        ),
        iroas: options.roasData.iroas,
      }),
      visible: options.customFields.includedSlides.sales.campaignOverview2,
    }),
    ...salesDimensionsSlides({
      topRetailers: options.topRetailers,
      salesMetrics: options.report,
      subdimensionsByName: options.topSalesSubdimensionsByName,
      recommendations: options.customFields.salesDimensionRecommendations,
      includedSlides: options.customFields.includedSlides.sales,
      subdimensionImages: options.customFields.subdimensionImagesByNameAndValue,
    }),
    ...visibleSlide({
      slide: recommendationsSlide(
        options.customFields.recommendations.map(r => r.value),
        headerTabs('recommendations')
      ),
      visible: options.customFields.includedSlides.takeaways.recommendations,
    }),
    ...visibleSlide({
      slide: discoverWhatsNextSlide({
        observations: options.customFields.observations.map(o => o.value),
      }),
      visible: options.customFields.includedSlides.takeaways.discoverWhatsNext,
    }),
  ];
};
